/* eslint-disable */
export default {
  account: 'アカウント',
  contact: '連絡先',
  lead: 'リード',
  opportunity: 'オポチュニティ',
  case: 'ケース',
  chooseEntity: 'エンティティタイプを選択してください',
  create: '作成',
} as const;

// @key: @#@"account"@#@ @source: @#@"Account"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"lead"@#@ @source: @#@"Lead"@#@
// @key: @#@"opportunity"@#@ @source: @#@"Opportunity"@#@
// @key: @#@"case"@#@ @source: @#@"Case"@#@
// @key: @#@"chooseEntity"@#@ @source: @#@"Please select entity type"@#@
// @key: @#@"create"@#@ @source: @#@"Create"@#@
